import PointsDisplay from '@/features/arcade/components/ArcadeLeaderboard/PointsDisplay'

type Props = {
  isSmallLayout: boolean
  points: number
}

export default function InventoryItemPoints({ isSmallLayout, points }: Props) {
  return (
    <PointsDisplay
      style={{
        fontSize: isSmallLayout
          ? 'clamp(12px, 1.5em, 1.5em)'
          : 'clamp(12px, 1.9em, 1.9em)'
      }}
      value={points}
      showSuffix={false}
      className=" text-arcadeGreen"
      iconClassName="w-[1.175em] h-[1.175em] text-white"
    />
  )
}
